import React, { ReactElement } from 'react';

export function getChildren(
  childrenArray: React.ReactNode[],
  pageLocation: (children: React.ReactNode) => React.ReactChild
): React.ReactNode[] {
  const children = childrenArray.find(
    (child: ReactElement) => child.type === pageLocation
  );

  if (!children) return [];

  return extractContainerChildren(children);
}

function extractContainerChildren(child: React.ReactNode) {
  return React.Children.toArray((child as ReactElement).props.children);
}
